import type { ExpressionSpecification } from 'mapbox-gl';
import type { LayerProps } from 'react-map-gl/mapbox';

const convertNominal = (nominal: number, zoom: number): number =>
  nominal * 2 ** (zoom - 16.5);

const widthInterpolation = (nominal: number): ExpressionSpecification => [
  'interpolate',
  ['exponential', 2],
  ['zoom'],
  // min at zoom 15
  15,
  convertNominal(nominal, 15),
  // max at zoom 18
  18,
  convertNominal(nominal, 18),
];

const iconSizeInterpolation = (nominal: number): ExpressionSpecification => [
  'interpolate',
  ['exponential', 2],
  ['zoom'],
  // min at zoom 15
  15,
  convertNominal(nominal, 15) / 50,
  // max at zoom 18
  18,
  convertNominal(nominal, 18) / 50,
];

export const clusterCasingLayer: LayerProps = {
  filter: ['has', 'point_count'],
  layout: { 'circle-sort-key': 1 },
  paint: {
    'circle-color': 'white',
    'circle-radius': ['step', ['get', 'point_count'], 22, 5, 32],
  },
  type: 'circle',
};

export const clusterLayer: LayerProps = {
  filter: ['has', 'point_count'],
  layout: { 'circle-sort-key': 10 },
  paint: {
    'circle-color': ['step', ['get', 'point_count'], '#c0c0c0', 5, '#d0d0d0'],
    'circle-radius': ['step', ['get', 'point_count'], 20, 5, 30],
  },
  type: 'circle',
};

export const clusterCountLayer: LayerProps = {
  filter: ['has', 'point_count'],
  layout: {
    'icon-allow-overlap': true,
    'text-allow-overlap': true,
    'text-field': '{point_count_abbreviated}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 14,
  },
  type: 'symbol',
};

export const unclusteredPointCasingLayer: LayerProps = {
  filter: ['!', ['has', 'point_count']],
  layout: { 'circle-sort-key': 1 },
  paint: {
    'circle-color': 'white',
    // 'circle-opacity': opacityInterpolation(),
    'circle-radius': widthInterpolation(30),
  },
  type: 'circle',
};

export const unclusteredPointLayer: LayerProps = {
  filter: ['!', ['has', 'point_count']],
  layout: { 'circle-sort-key': 10 },
  paint: {
    'circle-color': ['get', 'color'],
    'circle-radius': widthInterpolation(25),
  },
  type: 'circle',
};

export const symbolPointLayer: LayerProps = {
  filter: ['all', ['!', ['has', 'point_count']], ['has', 'symbol']],
  layout: {
    'icon-allow-overlap': true,
    'icon-image': ['get', 'symbol'],
    'icon-size': iconSizeInterpolation(25 - 1.75),
    'symbol-sort-key': 20,
    'text-allow-overlap': true,
  },
  paint: {
    'icon-color': 'yellow',
    // 'circle-color': 'red',
    // 'circle-radius': widthInterpolation(25),
  },
  type: 'symbol',
};
